import Vue from "vue";
import Router from "vue-router";
// import Signin from "@/views/Signin.vue";
// import Home from "@/views/Home.vue";
import store from "@/store";
import { getHost } from "@/helpers/url";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/signin",
      name: "signin",
      // component: Signin,
      component: () =>
        import(/* webpackChunkName: "signin" */ "@/views/Signin.vue"),
      beforeEnter: guardExternal
    },
    {
      path: "/",
      name: "home",
      // component: Home,
      component: () =>
        import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
      beforeEnter: guardInternal
    },
    {
      path: "/bankpay",
      name: "bankpay",
      component: () =>
        import(/* webpackChunkName: "bankpay" */ "@/views/Bankpay.vue"),
      beforeEnter: guardInternal
    },
    {
      path: "/packsreceipts",
      name: "packsreceipts",
      component: () =>
        import(
          /* webpackChunkName: "packsreceipts" */ "@/views/Packsreceipts.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/relationship",
      name: "relationship",
      component: () =>
        import(
          /* webpackChunkName: "relationship" */ "@/views/Relationship.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/assignoperators",
      name: "assignoperators",
      component: () =>
        import(
          /* webpackChunkName: "assignoperators" */ "@/views/Assignoperators.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/controlpacks",
      name: "controlpacks",
      component: () =>
        import(
          /* webpackChunkName: "controlpacks" */ "@/views/Controlpacks.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/controlinetpays",
      name: "controlinetpays",
      component: () =>
        import(
          /* webpackChunkName: "controlinetpays" */ "@/views/Controlinetpays.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/subscribers",
      name: "subscribers",
      component: () =>
        import(/* webpackChunkName: "subscribers" */ "@/views/Subscribers.vue"),
      beforeEnter: guardInternal
    },
    {
      path: "/errorpayments",
      name: "errorpayments",
      component: () =>
        import(
          /* webpackChunkName: "subscribers" */ "@/views/Errorpayments.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/enteringpayments",
      name: "enteringpayments",
      component: () =>
        import(
          /* webpackChunkName: "enteringpayments" */ "@/views/Enteringpayments.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/enteringsubsidies",
      name: "enteringsubsidies",
      component: () =>
        import(
          /* webpackChunkName: "enteringsubsidies" */ "@/views/Enteringsubsidies.vue"
        ),
      beforeEnter: guardInternal
    },
    {
      path: "/settings",
      name: "settings",
      component: () =>
        import(/* webpackChunkName: "settings" */ "@/views/Settings.vue"),
      beforeEnter: guardInternal
    },
    {
      path: "/reports",
      name: "reports",
      beforeEnter: () => {
        // window.location.href = `${getHost()}reports`;
        window.open(`${getHost()}reports/`, "_blank");
      }
    },
    // {
    //   path: "/acceptedshipment",
    //   name: "acceptedshipment",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "settings" */ "@/views/Acceptedshipment.vue"
    //     ),
    //   beforeEnter: guardInternal
    // },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

function guardExternal(to, from, next) {
  store.getters.isUserSignin ? next("/") : restoreSession("external", next);
}

function guardInternal(to, from, next) {
  store.getters.isUserSignin ? next() : restoreSession("internal", next);
}

function restoreSession(callFrom, next) {
  let wbConnection = {
    login: "",
    language: "",
    external: false
  };
  const savedConnection = Vue.localStorage.get("wb-connection");
  if (savedConnection) {
    const connect = JSON.parse(savedConnection);
    wbConnection = {
      login: connect.login || "",
      language: connect.language || "",
      external: connect.external || false
    };
  }

  let wbAuth = {
    url: "",
    label: "",
    token: "",
    tokenid: "",
    userid: ""
  };
  const savedAuth = Vue.localStorage.get("wb-auth");
  if (savedAuth) {
    const auth = JSON.parse(savedAuth);
    wbAuth = {
      url: auth.url || "",
      label: auth.label || "",
      token: auth.token || "",
      tokenid: auth.tokenid || "",
      userid: auth.userid || ""
    };
  }

  const checkConnection =
    wbConnection.login !== "" && wbConnection.language !== "";
  const checkAuth =
    wbAuth.url !== "" &&
    wbAuth.label !== "" &&
    wbAuth.token !== "" &&
    wbAuth.tokenid !== "" &&
    wbAuth.userid !== "";

  if (checkConnection && checkAuth) {
    store.commit("setUser", {
      login: wbConnection.login,
      language: wbConnection.language,
      token: wbAuth.token,
      tokenid: wbAuth.tokenid,
      userid: wbAuth.userid
    });
    store.commit("setBase", {
      url: wbAuth.url,
      label: wbAuth.label
    });
    store.commit("setExternalAuth", wbConnection.external);

    callFrom === "internal" ? next() : next("/");
  } else {
    callFrom === "internal" ? next("/signin") : next();
  }
}
